
import hamburgerIcon from 'fjaka/js/components/hamburger-icon';
import './components/accordion'
import './components/archive-filter'
import './components/bs.scrollspy'
import './components/carousel'
import './components/header'
import './components/modal'
import './components/offcanvas'
import './components/reading-time'
import './components/search'
import './components/select'
import './components/smooth-scroll'
import './components/pardot-form'
import './components/promo-banner'
import './components/typed-text'
import './components/vertical-tabs'

// Hamburger icon
hamburgerIcon( $ )

// Scrollspy
$( 'body' ).scrollspy({
	target: '.js-scrollspy-nav',
	offset: 105,
})
